import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Basic 404 error page, we will need to clean this up but i needed something rn.
const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
      bgcolor="#f5f5f5"
    >
      <Typography variant="h3" color="textPrimary" gutterBottom>
        404 Error
      </Typography>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        Something went wrong :(
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate('/')}>
        Go Back to Home
      </Button>
    </Box>
  );
};

export default NotFoundPage;
